import {useSearchParams} from "react-router-dom";

export const GtaRatesFilterType = {
    Search: 'search',
    Page: 'page',
    PageSize: 'page_size',
    Status: 'status',
} as const;

export type GtaRatesFilterType = typeof GtaRatesFilterType[keyof typeof GtaRatesFilterType];


export default function useGetGtaRatesFiltersQuery() {
    const [searchParams] = useSearchParams();

    const searchQuery = searchParams.get(GtaRatesFilterType.Search);
    const pageQuery = searchParams.get(GtaRatesFilterType.Page);
    const pageSizeQuery = searchParams.get(GtaRatesFilterType.PageSize);
    const statusQuery = searchParams.get(GtaRatesFilterType.Status);

    return {
        pageSizeQuery,
        pageQuery,
        searchQuery,
        statusQuery
    };
}
